var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9992 9.54041C6.9992 9.61455 7.03163 9.68405 7.09648 9.74891C7.16134 9.81376 7.24013 9.84619 7.33276 9.84619H8.66692C8.75956 9.84619 8.83835 9.81376 8.9032 9.74891C8.96806 9.68405 9.00049 9.61455 9.00049 9.54041L9.22283 5.76027C9.22283 5.64905 9.1904 5.56106 9.12555 5.49621C9.0607 5.43135 8.9819 5.39893 8.88927 5.39893H7.11042C7.01778 5.39893 6.93899 5.43135 6.87414 5.49621C6.80928 5.56106 6.77686 5.64905 6.77686 5.76027L6.9992 9.54041ZM7.09664 10.7217C6.84651 10.9718 6.72145 11.273 6.72145 11.625C6.72145 11.9772 6.84651 12.2782 7.09664 12.5284C7.34686 12.7785 7.6479 12.9036 8.00005 12.9036C8.3521 12.9036 8.65314 12.7785 8.90336 12.5284C9.15349 12.2782 9.27855 11.9772 9.27855 11.625C9.27855 11.273 9.15349 10.9718 8.90336 10.7217C8.65314 10.4715 8.3521 10.3464 8.00005 10.3464C7.6479 10.3464 7.34686 10.4715 7.09664 10.7217ZM15.5325 14.4184C15.2916 14.6315 15.0044 14.7381 14.6708 14.7381H1.32915C0.995589 14.7381 0.70839 14.6315 0.467463 14.4184C0.226535 14.2053 0.0783365 13.9459 0.0227736 13.6402C-0.0328822 13.3345 0.0134822 13.0333 0.161774 12.7368L6.83257 1.17407C6.99936 0.877582 7.23564 0.678373 7.54133 0.576445C7.84711 0.474518 8.15289 0.474518 8.45867 0.576445C8.76436 0.678373 9.00064 0.877582 9.16743 1.17407L15.8382 12.7368C15.9865 13.0333 16.0329 13.3345 15.9772 13.6402C15.9217 13.9459 15.7735 14.2053 15.5325 14.4184Z",
    fill: "#3B3C45"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Warning.e35998f384063003083b03efe0c485f9.svg";